export function shouldResetEphemeralState(conversationState = null) {
  return (
    conversationState?.lifecycle?.shouldResetEphemeral === true ||
    conversationState?.control?.shouldResetEphemeral === true
  );
}

export function getActiveReferencedEntity({
  conversationState = null,
  memoryState = {},
} = {}) {
  const turnOperations =
    conversationState?.activeFrameState?.situation?.turnOperations || null;
  const activeRequestTarget = turnOperations?.activeRequestTarget || null;
  const hasUnresolvedRelationshipRequest = Boolean(
    turnOperations?.requestedRole && !activeRequestTarget
  );

  if (activeRequestTarget) return activeRequestTarget;
  if (hasUnresolvedRelationshipRequest) return null;

  const entityStateActive = conversationState?.entityState?.active || null;
  const currentEntity = conversationState?.reference?.lastReferencedEntity || null;
  const shouldReset = shouldResetEphemeralState(conversationState);

  if (currentEntity) return currentEntity;
  if (entityStateActive) return entityStateActive;
  if (shouldReset) return null;

  return memoryState?.lastReferencedEntity || null;
}

export function getActiveReferencedTopic({
  conversationState = null,
  memoryState = {},
} = {}) {
  const currentTopic = conversationState?.reference?.lastReferencedTopic || null;
  const shouldReset = shouldResetEphemeralState(conversationState);

  if (currentTopic) return currentTopic;
  if (shouldReset) return null;

  return memoryState?.lastReferencedTopic || null;
}

export function buildPromptMemoryState({
  memoryState = {},
  conversationState = null,
} = {}) {
  const shouldReset = shouldResetEphemeralState(conversationState);
  const entityStateActive = conversationState?.entityState?.active || null;
  const objectiveDecisionState =
    conversationState?.objectiveDecisionState || null;
  const turnSignalArbitration =
    conversationState?.turnSignalArbitration || null;
  const turnOperations =
    conversationState?.activeFrameState?.situation?.turnOperations || null;
  const activeRequestTarget = turnOperations?.activeRequestTarget || null;
  const hasUnresolvedRelationshipRequest = Boolean(
    turnOperations?.requestedRole && !activeRequestTarget
  );

  const projectedReferencedEntity =
    activeRequestTarget ||
    (hasUnresolvedRelationshipRequest
      ? null
      : conversationState?.reference?.lastReferencedEntity ||
        entityStateActive ||
        memoryState?.lastReferencedEntity ||
        null);

  if (!shouldReset) {
    return {
      ...memoryState,
      frame: conversationState?.frame || memoryState?.frame || null,
      lastReferencedEntity: projectedReferencedEntity,
      lastReferencedTopic:
        conversationState?.reference?.lastReferencedTopic ||
        memoryState?.lastReferencedTopic ||
        null,
      activeObjective:
        objectiveDecisionState?.activeObjective ||
        memoryState?.activeObjective ||
        null,
      activeDecision:
        objectiveDecisionState?.activeDecision ||
        memoryState?.activeDecision ||
        null,
      activeReasoningChain:
        objectiveDecisionState?.activeReasoningChain ||
        memoryState?.activeReasoningChain ||
        [],
      objectiveDecisionState,
      turnSignalArbitration,
      activeFrameState: conversationState?.activeFrameState || null,
      intentState:
        conversationState?.intentState ||
        memoryState?.intentState ||
        null,
      activeUserIntent:
        conversationState?.intentState?.activeUserIntent ||
        memoryState?.activeUserIntent ||
        null,
      turnFunction:
        conversationState?.intentState?.turnFunction ||
        memoryState?.turnFunction ||
        null,
      responseIntent:
        conversationState?.intentState?.responseIntent ||
        memoryState?.responseIntent ||
        null,
    };
  }

  return {
    ...memoryState,
    frame: conversationState?.frame || null,
    lastReferencedEntity: null,
    lastReferencedTopic: null,
    pendingQuestion: null,
    lastSearchTopic: null,
    activeObjective: null,
    activeDecision: null,
    activeReasoningChain: [],
    objectiveDecisionState,
    turnSignalArbitration,
    activeFrameState: conversationState?.activeFrameState || null,
    intentState: conversationState?.intentState || null,
    activeUserIntent: null,
    turnFunction: conversationState?.intentState?.turnFunction || null,
    responseIntent: conversationState?.intentState?.responseIntent || null,
  };
}
